<template>
  <div class="oauth-callback">
    <div class="callback-content">
      <div v-if="loading" class="loading-state">
        <div class="spinner"></div>
        <p>Completing sign in...</p>
      </div>
      <div v-else-if="error" class="error-state">
        <h2>Sign In Failed</h2>
        <p>{{ error }}</p>
        <button @click="goHome" class="home-button">Go to Home</button>
      </div>
      <div v-else class="success-state">
        <h2>Sign In Successful!</h2>
        <p>Redirecting...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { handleOAuthCallback } from '@/utils/oauth'
import { API_ENDPOINTS } from '@/constants'
import api from '@/api'
import logger from '@/utils/logger'
import { ROUTES } from '@/constants'

export default {
  name: 'OAuthCallback',
  data() {
    return {
      loading: true,
      error: null
    }
  },
  async mounted() {
    await this.processCallback()
  },
  methods: {
    async processCallback() {
      try {
        // Extract token from URL
        const result = handleOAuthCallback()
        
        if (!result || !result.token) {
          this.error = 'No authentication token found. Please try signing in again.'
          this.loading = false
          return
        }

        const { token, provider } = result

        // Fetch user info with the token
        try {
          const userResponse = await api.get(API_ENDPOINTS.ME, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          })

          // Store auth in Vuex
          this.$store.commit('auth/setAuth', {
            token,
            user: userResponse.data
          })

          logger.info('OAuth authentication successful', { provider })

          // Redirect to home or intended destination
          setTimeout(() => {
            this.$router.push(ROUTES.HOME)
          }, 1000)

        } catch (error) {
          logger.error('Failed to fetch user info after OAuth', { error: error.message })
          this.error = 'Failed to complete sign in. Please try again.'
          this.loading = false
        }

      } catch (error) {
        logger.error('OAuth callback processing failed', { error: error.message })
        this.error = 'An error occurred during sign in. Please try again.'
        this.loading = false
      }
    },
    goHome() {
      this.$router.push(ROUTES.HOME)
    }
  }
}
</script>

<style scoped>
.oauth-callback {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #fbf6e9;
}

.callback-content {
  background: #ffffff;
  border-radius: 12px;
  padding: 3rem;
  text-align: center;
  box-shadow: 0 8px 24px rgba(14, 59, 46, 0.08), 0 2px 6px rgba(14, 59, 46, 0.04);
  border: 1px solid #e2e8df;
  max-width: 400px;
  width: 90%;
}

.loading-state,
.success-state,
.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e3eae3;
  border-top-color: #0e3b2e;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-state p,
.success-state p {
  color: #475569;
  margin: 0;
}

.error-state h2 {
  color: #b91c1c;
  margin: 0 0 0.5rem 0;
}

.error-state p {
  color: #475569;
  margin: 0 0 1.5rem 0;
}

.home-button {
  background: #0e3b2e;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: background 0.2s;
}

.home-button:hover {
  background: #134d3c;
}

.success-state h2 {
  color: #0e3b2e;
  margin: 0 0 0.5rem 0;
}
</style>



